export enum ProductType {

    Board = "board",
    Kyc = "kyc",
    Professional = "professional",
    Documents = "documents",
    DepositLimits = "deposit-limits",
    ShareInformation = "share-information",
}
